import { render } from "./SettingsPage.vue?vue&type=template&id=3c57c4dc&scoped=true"
import script from "./SettingsPage.vue?vue&type=script&lang=js"
export * from "./SettingsPage.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3c57c4dc"

export default script